import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  const {type, appbar, getContrastText} = theme.palette;
  const bckg = appbar[type];
  const color = getContrastText(bckg);
  return {
    AppBar: {
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "space-between",
      alignItems: "center",
      position: "relative",
      width: "100%",
      height: "40px",
      marginBottom: 0,
      padding: 0,
      background: bckg,
      zIndex: theme.zIndex.drawer + 2,
      borderBottom: "thin solid",
      borderBottomColor: theme.palette.action.disabledBackground,
      boxSizing: "border-box"
    },
    menuIcon: {
      marginLeft: 10,
      cursor: "pointer",
      color
    },
    disabledMenuButton: {
      opacity: 0.5
    },
    linkContainer: {
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "flex-start",
      alignItems: "center",
      maxWidth: 250,
      height: 38
    },
    clearDev: {
      color,
      cursor: "pointer",
      borderRadius: "5px",
      padding: theme.spacing(0.5),
      marginRight: theme.spacing(1),
      "&:hover": {
        background: theme.palette.action.hover
      }
    },
    Link: {
      height: 38,
      color: theme.palette.link[type === "dark" ? "light" : "dark"],
      width: "auto",
      "&:hover": {
        outline: "none"
      }
    },
    Icon: {
      display: "inline-block",
      verticalAlign: "top",
      height: "28px",
      marginLeft: "5px",
      marginRight: "5px"
    },
    MenuLogo: {
      marginLeft: "10px",
      height: "36",
      marginTop: "2px",
      width: "54px",
      "& .tau": {
        fill: color
      },
      cursor: "pointer"
    },
    LeftSide: {
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "flex-start",
      alignItems: "center",
      height: "100%"
    },
    RightSide: {
      display: "flex",
      flexFlow: "row nowrap",
      height: "100%",
      justifyContent: "flex-end",
      alignItems: "center"
    }
  };
});
